'use client';

import { useEffect, useState } from 'react';
import { company } from '@/lib/company';

const TIME_FORMAT = new Intl.DateTimeFormat('en-CA', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  timeZone: company.timeZone,
});

/** Local time at the registered office (America/Toronto — DST aware). */
export function officeTime(date: Date = new Date()): string {
  return TIME_FORMAT.format(date);
}

/**
 * Tiny live "the studio is on" line for the hero — local time at the
 * registered office in Ontario, with a breathing accent dot. Renders a
 * placeholder until mounted so the statically exported HTML never carries a
 * stale build-time clock.
 */
export function HeroStatusLine({ className = '' }: { className?: string }) {
  const [time, setTime] = useState<string | null>(null);

  useEffect(() => {
    const update = () => setTime(officeTime());
    update();
    const interval = setInterval(update, 30_000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`items-center gap-3 font-mono text-[11px] tracking-[0.28em] uppercase text-white/40 ${className}`}
      aria-hidden="true"
    >
      <span
        className="h-1.5 w-1.5 rounded-full animate-pulse"
        style={{ backgroundColor: 'var(--color-accent, #34d399)' }}
      />
      <span suppressHydrationWarning>
        Bradford, Ontario · {time ?? '--:--'} local time
      </span>
    </div>
  );
}
